module.exports = __webpack_public_path__ + "static/media/Huevo.4d40cdad.png";